
import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { SetupSteps } from "./SetupSteps";
import { X } from "lucide-react";

interface SetupGuideDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialStep?: string;
}

export function SetupGuideDialog({ open, onOpenChange, initialStep }: SetupGuideDialogProps) {
  const { toast } = useToast();
  const [skipped, setSkipped] = useState(false);

  const handleSkip = () => {
    setSkipped(true);
    onOpenChange(false);
    toast({
      title: "Setup skipped",
      description: "You can always access the setup guide from the settings page later.",
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl h-[calc(90vh-2rem)] p-0 flex flex-col overflow-hidden">
        <DialogHeader className="p-6 pb-2 sticky top-0 bg-background z-10 border-b">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-xl font-semibold">Welcome to Subtrackr</DialogTitle>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onOpenChange(false)}
              className="rounded-full"
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </Button>
          </div>
          <p className="text-muted-foreground mt-2">
            Let's set up your account with a few quick steps to get you started.
          </p>
        </DialogHeader>

        <div className="flex-1 overflow-hidden">
          {!skipped && <SetupSteps initialStep={initialStep} onComplete={() => onOpenChange(false)} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
